const ErrorPage = () => (
  <div>
    404: Not found
  </div>
);

export default ErrorPage;
